import React from 'react';

const SmtpConfigPanel = ({ smtpConfig, setSmtpConfig, smtpSaving, schedulerStatus,
  showSmtpForm, setShowSmtpForm, onSave, onTest }) => (
  <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
    <div className="flex items-start justify-between mb-4 gap-3 flex-wrap">
      <div className="min-w-0">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900">SMTP Configuration</h2>
        <p className="text-sm text-gray-600">Configure email server settings for sending reports</p>
      </div>
      <button onClick={() => setShowSmtpForm(!showSmtpForm)} className="bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-2.5 px-4 min-h-[44px] rounded-lg transition-colors whitespace-nowrap">
        {showSmtpForm ? 'Hide Settings' : 'Configure SMTP'}
      </button>
    </div>

    <div className={`p-3 sm:p-4 rounded-lg border ${schedulerStatus?.smtp_configured ? 'bg-green-50 border-green-200' : 'bg-yellow-50 border-yellow-200'} mb-4`}>
      <p className={`text-sm ${schedulerStatus?.smtp_configured ? 'text-green-800' : 'text-yellow-800'}`}>
        {schedulerStatus?.smtp_configured ? 'SMTP is configured' : 'SMTP not configured - emails will not be sent'}
      </p>
    </div>

    {showSmtpForm && (
      <div className="border-t pt-4 mt-4 space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">SMTP Host</label>
            <input type="text" value={smtpConfig.smtp_host} onChange={(e) => setSmtpConfig({ ...smtpConfig, smtp_host: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#156ACA]" placeholder="smtp.gmail.com" data-testid="smtp-host-input" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">SMTP Port</label>
            <select value={smtpConfig.smtp_port} onChange={(e) => setSmtpConfig({ ...smtpConfig, smtp_port: parseInt(e.target.value) })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#156ACA]" data-testid="smtp-port-select">
              <option value={587}>587 (TLS - Recommended)</option>
              <option value={465}>465 (SSL)</option>
              <option value={25}>25 (Unencrypted)</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">SMTP Username</label>
            <input type="text" value={smtpConfig.smtp_user} onChange={(e) => setSmtpConfig({ ...smtpConfig, smtp_user: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#156ACA]" placeholder="your-email@domain.com" data-testid="smtp-user-input" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">SMTP Password</label>
            <input type="password" value={smtpConfig.smtp_password} onChange={(e) => setSmtpConfig({ ...smtpConfig, smtp_password: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#156ACA]" placeholder="Enter password" data-testid="smtp-password-input" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">From Email</label>
            <input type="email" value={smtpConfig.smtp_from_email} onChange={(e) => setSmtpConfig({ ...smtpConfig, smtp_from_email: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#156ACA]" placeholder="noreply@yourdomain.com" data-testid="smtp-from-input" />
          </div>
          <div className="flex items-center">
            <label className="flex items-center cursor-pointer">
              <input type="checkbox" checked={smtpConfig.use_tls} onChange={(e) => setSmtpConfig({ ...smtpConfig, use_tls: e.target.checked })} className="mr-2 h-5 w-5" />
              <span className="text-sm font-medium text-gray-700">Use TLS Encryption</span>
            </label>
          </div>
        </div>

        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 sm:gap-3 mt-4">
          <button onClick={onTest} disabled={smtpSaving || !smtpConfig.smtp_host || !smtpConfig.smtp_user}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5 px-4 min-h-[44px] rounded-lg transition-colors disabled:opacity-50" data-testid="test-smtp-btn">
            {smtpSaving ? 'Testing...' : 'Test Connection'}
          </button>
          <button onClick={onSave} disabled={smtpSaving || !smtpConfig.smtp_host || !smtpConfig.smtp_user || !smtpConfig.smtp_password}
            className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2.5 px-4 min-h-[44px] rounded-lg transition-colors disabled:opacity-50" data-testid="save-smtp-btn">
            {smtpSaving ? 'Saving...' : 'Save SMTP Settings'}
          </button>
        </div>

        <div className="mt-4 p-4 bg-gray-50 rounded-lg text-sm text-gray-600">
          <strong>Common SMTP Settings:</strong>
          <ul className="list-disc ml-5 mt-2 space-y-1">
            <li><strong>Gmail:</strong> smtp.gmail.com, Port 587, Use App Password</li>
            <li><strong>Outlook:</strong> smtp.office365.com, Port 587</li>
            <li><strong>SendGrid:</strong> smtp.sendgrid.net, Port 587</li>
          </ul>
        </div>
      </div>
    )}
  </div>
);

export default SmtpConfigPanel;
